import * as React from "react"

function FbIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={31.189}
      height={31}
      viewBox="0 0 31.189 31"
      {...props}
    >
      <path d="M31.189 15.595A15.595 15.595 0 1013.158 31V20.1h-3.96v-4.505h3.96v-3.436c0-3.908 2.328-6.067 5.891-6.067a23.965 23.965 0 013.49.3v3.838h-1.967a2.254 2.254 0 00-2.541 2.435v2.925h4.325l-.691 4.512h-3.634v10.9a15.6 15.6 0 0013.158-15.407z" />
    </svg>
  )
}

export default FbIcon